import { useEffect } from 'react';
import { useTheme } from 'styled-components';

export function useFavicon(systemInformation) {
  const theme = useTheme();

  function change() {
    const link = document.createElement('link');
    const url = systemInformation.pcFicoImgFilePath;
    link.rel = 'icon';
    link.href = `${url}?=${Date.now()}`;
    link.type = 'image/x-icon';

    document.head.appendChild(link);
  }

  function deleteAll() {
    document.querySelectorAll("link[rel~='icon']").forEach((e) => e.remove());
  }

  useEffect(() => {
    deleteAll();
    change();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme.favicon]);
}
